interface IUseDefaultRouteDetails {
  isMapReady: boolean;
  overviewPolyline?: string;
  legs?: RouteLegInfo[] | SuggestedLeg[];
}

export const useDefaultRouteDetails = ({
  isMapReady,
  overviewPolyline,
  legs,
}: IUseDefaultRouteDetails): RouteDetails | undefined => {
  return isMapReady && overviewPolyline
    ? {
        plannedPath: window.google.maps?.geometry.encoding.decodePath(overviewPolyline),
        legs: legs || [],
      }
    : undefined;
};
